var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"input":_vm.valueChange},model:{value:(_vm.dataValue),callback:function ($$v) {_vm.dataValue=$$v},expression:"dataValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }